import {api} from '../../contexts/AuthContext';
import {Company, CreateCompanyData} from '../../types';

// Company API (Admin only)
export const companyApi = {
    getAll: async (): Promise<Company[]> => {
        const response = await api.get('/api/companies');
        return response.data;
    },

    getById: async (id: string): Promise<Company> => {
        const response = await api.get(`/api/companies/${id}`);
        return response.data;
    },

    create: async (companyData: CreateCompanyData): Promise<Company> => {
        const response = await api.post('/api/companies', companyData);
        return response.data;
    },

    update: async (id: string, updates: Partial<Company>): Promise<Company> => {
        const response = await api.put(`/api/companies/${id}`, updates);
        return response.data;
    },

    delete: async (id: string): Promise<void> => {
        await api.delete(`/api/companies/${id}`);
    }
};
